<div class="release-note--container">
  <div class="category-date--container">
    <div class="categories">
      @for (category of releaseNote().categories; track category) {
        <app-category [category]="category"></app-category>
      }
    </div>
    <div class="body1 date">
      {{ releaseNote().datePublished | date: "MMMM d, y" }}
    </div>
  </div>
  <div class="note--container">
    <div class="subtitle2">
      <div>{{ releaseNote().webAppVersion }}</div>
      <div>{{ releaseNote().deviceVersion }}</div>
    </div>
    <div class="section-title">
      {{ releaseNote().header }}
    </div>
    <ul>
      @for (item of releaseNote().summary; track item) {
        <li class="body1">{{ item }}</li>
      }
    </ul>
    @if (!hideNote()) {
      <div class="expanded-notes">
        @for (outerSection of releaseNote().notes; track outerSection) {
          <div class="note">
            <div class="section-category">{{ outerSection.sectionCategory }}</div>
            @for (bodySection of outerSection.sectionBody; track bodySection) {
              <div class="note-detail">
                @if (bodySection.title) {
                  <span class="body1 title">{{ bodySection.title }}</span>
                }
                <ul>
                  @for (desc of bodySection.description; track desc) {
                    <li class="body1">{{ desc }}</li>
                  }
                </ul>
              </div>
            }
          </div>
        }
      </div>
    }
    </div>
  <div class="show-more-button--container">
    <app-icon-button
      [label]="hideNote() ? 'show more' : 'Show less'"
      [iconName]="hideNote() ? 'keyboard_arrow_down' : 'keyboard_arrow_up'"
      buttonStyle="transparent--blue"
      buttonId="show-more-btn"
      buttonShape="square"
      (buttonClicked)="handleButtonClicked()"
      [title]="hideNote() ? 'Show More' : 'Show Less'"
    ></app-icon-button>
  </div>
</div>
